import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectionService {
  private readonly DESKTOP_BREAKPOINT = 992; // lg breakpoint
  private isDesktopSubject = new BehaviorSubject<boolean>(false);
  private readonly isNative = Capacitor.isNativePlatform();

  constructor() {
    this.checkScreenSize();
    this.setupResizeListener();
  }

  get isDesktop$(): Observable<boolean> {
    return this.isDesktopSubject.asObservable();
  }

  get isDesktop(): boolean {
    return this.isDesktopSubject.value;
  }

  get isMobile(): boolean {
    return !this.isDesktop;
  }

  private checkScreenSize(): void {
    // Native apps are always mobile
    if (this.isNative) {
      this.isDesktopSubject.next(false);
      return;
    }

    // Web: check window width
    if (typeof window !== 'undefined') {
      const isDesktop = window.innerWidth >= this.DESKTOP_BREAKPOINT;
      this.isDesktopSubject.next(isDesktop);
    }
  }

  private setupResizeListener(): void {
    if (typeof window !== 'undefined' && !this.isNative) {
      window.addEventListener('resize', () => this.checkScreenSize());
    }
  }

  public forceCheck(): void {
    this.checkScreenSize();
  }
}
